import { useState, useEffect } from 'react'

interface UseFullscreenOptions {
  readOnly?: boolean
  defaultFullscreen?: boolean
}

/**
 * Manages fullscreen toggle state with keyboard shortcuts.
 * - Esc to exit fullscreen
 * - Cmd/Ctrl + Shift + F to toggle
 * Disabled in read-only mode.
 */
export function useFullscreen({ readOnly = false, defaultFullscreen = false }: UseFullscreenOptions) {
  const [isFullscreen, setIsFullscreen] = useState(defaultFullscreen)

  useEffect(() => {
    if (readOnly) return

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isFullscreen) {
        setIsFullscreen(false)
      }
      if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key === 'f') {
        e.preventDefault()
        setIsFullscreen(!isFullscreen)
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isFullscreen, readOnly])

  return { isFullscreen, setIsFullscreen }
}
